<template>
  <div>
    <b-row>
      <b-col
        xl="4"
        sm="6"
      >
        <b-card class="card card-credit-limit-1">
          <feather-icon
            icon="PieChartIcon"
            size="35"
            class="dashboard-left-icon mt-1 text-white"
          />
          <div>
            <h5 class="text-white text-capitalize ml-2">
              <span style="font-size: 25px; font-weight: 600; margin-left: 5px;">
                {{ adminDashboards.totalApprovedCreditLimit }}
              </span>
            </h5>
            <b-card-text class="card-title text-white ml-0 mt-3 mb-0">
              Approved Credit Limit
            </b-card-text>
          </div>
        </b-card>
      </b-col>

      <b-col
        xl="4"
        sm="6"
      >
        <b-card class="card card-credit-limit-2">
          <feather-icon
            icon="BarChartIcon"
            size="35"
            class="dashboard-left-icon mt-1 text-white"
          />
          <div>
            <h5 class="text-white text-capitalize ml-2">
              <span style="font-size: 25px; font-weight: 600; margin-left: 5px;">
                {{ adminDashboards.totalAvailableCreditLimit }}
              </span>
            </h5>
            <b-card-text class="card-title text-white ml-0 mt-3 mb-0">
              Available Credit Limit
            </b-card-text>
          </div>
        </b-card>
      </b-col>

      <b-col
        xl="4"
        sm="6"
      >
        <b-card class="card card-credit-limit-3">
          <feather-icon
            icon="BarChart2Icon"
            size="35"
            class="dashboard-left-icon mt-1 text-white"
          />
          <div>
            <h5 class="text-white text-capitalize ml-2">
              <span style="font-size: 25px; font-weight: 600; margin-left: 5px;">
                {{ adminDashboards.totalOutstandingLoanBalance }}
              </span>
            </h5>
            <b-card-text class="card-title text-white ml-0 mt-3 mb-0">
              Outstanding Loan Balance
            </b-card-text>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        xl="3"
        sm="6"
      >
        <b-card
          class="card card-supplementary-1"
        >
          <div>
            <h5 class="text-white text-capitalize">
              <span class="value-format">{{ adminDashboards.totalAmountDisbursedFormatted }}</span>

            </h5>
            <b-card-text
              style="font-size:14px;"
              class="text-white"
            >
              Total Amount Disbursed
            </b-card-text>
          </div>

        </b-card>
      </b-col>
      <b-col
        xl="3"
        sm="6"
      >
        <b-card
          class="card card-supplementary-2"
        >
          <div>
            <h5 class="text-white text-capitalize">
              <span class="value-format">{{ adminDashboards.countOfApprovedLoans }}</span>

            </h5>
            <b-card-text
              style="font-size:14px;"
              class="text-white"
            >
              Approved Loans Count
            </b-card-text>
          </div>

        </b-card>
      </b-col>
      <b-col
        xl="3"
        sm="6"
      >
        <b-card
          class="card card-supplementary-3"
        >
          <div>
            <h5 class="text-white text-capitalize">
              <span class="value-format">{{ adminDashboards.countOfPendingLoans }}</span>

            </h5>
            <b-card-text
              style="font-size:14px;"
              class="text-white"
            >
              Pending Loans Count
            </b-card-text>
          </div>

        </b-card>
      </b-col>
      <b-col
        xl="3"
        sm="6"
      >
        <b-card
          class="card card-supplementary-4"
        >
          <div>
            <h5 class="text-white text-capitalize">
              <span class="value-format">{{ adminDashboards.countOfEndBorrowers }}</span>

            </h5>
            <b-card-text
              style="font-size:14px;"
              class="text-white"
            >
              End Borrowers Count
            </b-card-text>
          </div>

        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BCard, BCardText, BRow, BCol,
} from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'
import { useActions } from 'vuex-composition-helpers'
import useToastAlert from '../../../composable/useToast'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
  },
  setup() {
    const { getAdminDashboard } = useActions({ getAdminDashboard: 'dashboard/getCreditLimitOverview' })
    const { toastAlert } = useToastAlert()
    const adminDashboards = ref([])
    const isLoadingAdminDashboard = ref(false)
    const fetchAdminDashboard = async () => {
      try {
        isLoadingAdminDashboard.value = true
        const response = await getAdminDashboard({ permission: 'VIEW_ADMIN_APPROVALS' })
        const { status, data } = response
        if (status === 200 && data.adminData !== null) {
          adminDashboards.value = data.adminData
          isLoadingAdminDashboard.value = false
        }
      } catch (err) {
        toastAlert(err)
      } finally {
        isLoadingAdminDashboard.value = false
      }
    }
    onMounted(async () => {
      await fetchAdminDashboard()
    })
    return {
      adminDashboards,
      fetchAdminDashboard,
      isLoadingAdminDashboard,
    }
  },
}
</script>
<style lang="scss" scoped>
  .card-credit-limit-1 {
    background: #ac79df;
    color: white;
  }
  .card-credit-limit-2 {
    background: #d4b95e;
    color: white;
  }
  .card-credit-limit-3 {
    background: #dd5555;
    color: white;
  }
  .card-resize {
    margin-top: -10px;
    margin-bottom: -20px;
  }
    .card-supplementary-1 {
    background: #c5a5e6;
    color: white;
  }
  .card-supplementary-2 {
    background: #e0cf92;
    color: white;
  }
  .card-supplementary-3 {
    background: #9cb9bd;
    color: white;
  }
  .card-supplementary-4 {
    background: #ee8787;
    color: white;
  }
   .card-title {
    font-size:12px;
    font-weight: 600;
    word-break: break-word;
  }
  .value-format {
    font-size:23px;
    font-weight: 600;
    color: #000;
  }

</style>
